import { useField } from "formik"
import React from "react"
import { Checkbox } from "primereact/checkbox"
import { Skeleton } from "primereact/skeleton"
import { InputSwitch } from "primereact/inputswitch"

//Style
import styles from "../../styles/Form-Inputs.module.css"
import refStyles from "../../styles/Referrals.module.css"

export default function FormikCheckBox(props) {
  const [field, meta] = useField(props.name)

  const getCheckbox = () => {
    if (props.isInitialLoad) {
      return <Skeleton height="42px" width="42px" />
    } else {
      return (
        <>
          <div className="control">
            {props.useSwitch ? (
              <InputSwitch
                {...field}
                {...props}
                checked={field.value}
                className={`${refStyles.checkBox} ${
                  meta.touched && meta.error ? "p-invalid" : ""
                }`}
                disabled={props.disabled}
              />
            ) : (
              <Checkbox
                {...field}
                {...props}
                checked={field.value}
                className={`${refStyles.checkBox} ${
                  meta.touched && meta.error !== undefined ? "p-invalid" : ""
                }`}
                disabled={props.disabled}
              />
            )}
            {!!props.checkbox_label ? (
              <label style={{ marginLeft: "10px" }}>
                {props.checkbox_label}
              </label>
            ) : null}
          </div>
        </>
      )
    }
  }

  const getLabel = () => {
    if (props.isInitialLoad) {
      return <Skeleton width="10rem" height="1rem" />
    } else {
      return <label>{props.label}</label>
    }
  }

  return (
    <div className={`${styles.field} ${props.className || ""}`}>
      <div className="label">{getLabel()}</div>

      {props.helpText ? (
        <div style={{ marginBottom: "10px" }}>
          <small style={{ color: "gray" }}>{props.helpText}</small>
        </div>
      ) : null}
      {getCheckbox()}
      {meta.touched && meta.error ? (
        <div className="errorLabel">
          <label id={`${props.name}-error`} className={styles.errFieldMsg}>
            {meta.error}
          </label>
        </div>
      ) : null}
    </div>
  )
}
